import { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { resetRouteMetadata, updateRouteUrlMetadata } from '../utils/seo';
export default function RouteMetadata() {
  const { pathname, search } = useLocation();
  const previousPath = useRef<string>();
  useLayoutEffect(() => {
    if (previousPath.current !== pathname) resetRouteMetadata(pathname, search);
    else updateRouteUrlMetadata(pathname, search);
    previousPath.current = pathname;
  }, [pathname, search]);
  return null;
}
